<script>
    import {getContext, createEventDispatcher, onMount} from "svelte";
    import {fade} from 'svelte/transition';
    import {to, API} from "@API";

    export let showBranding = true;
    export let showBack = false;

    export let step;
    export let stepComplete

    const ValidateCoupon = API.service('shop/:product_slug/validate_coupon');
    const ApplyCoupon = API.service('stripe/:subscription/apply_coupon');
    const dispatch = createEventDispatcher();

    let {org, product, shopData} = getContext("SHOP");
    let priceType;
    let resolvedConfig = product.shop_coupon_configuration || org.shop_coupon_configuration || {};

    function calculatePrice(tier) {
        let price = {
            'original': (tier.unit_amount / 100).toFixed(2),
            'value': (tier.unit_amount / 100).toFixed(2)
        }
        if ($shopData.coupon && $shopData.coupon.metadata?.type !== 'admin_fee') {
            price.discounted = true;
            if ($shopData.coupon.percent_off) {
                price.value = (price.original - (price.original * ($shopData.coupon.percent_off / 100))).toFixed(2)
            } else {
                price.value = (price.original - $shopData.coupon.amount_off).toFixed(2)
            }
        }
        return price
    }

    function generatePrices(product) {
        let prices;
        if (product.tiers.length) {
            let basePrices = product.stripe_price.filter(p => p.type != 'one_time').reduce((all, item) => {
                all[item.recurring.interval] = {
                    ...item,
                    fakeTier: true,
                    base_price: item
                }
                return all
            }, {
                'year': null,
                'month': null
            })

            // create a fake tier which is always default
            let defaultTiers = {}

            prices = JSON.parse(JSON.stringify(product.tiers)).reduce((all, item) => {
                let tierPrice = {
                    'year': item.stripe_details.filter(i => i.recurring.interval == 'year')[0],
                    'month': item.stripe_details.filter(i => i.recurring.interval == 'month')[0]
                }
                Object.keys(tierPrice).reduce((all, key) => {
                    let price = tierPrice[key];
                    price.description = item.description;
                    price.unit_amount += basePrices[key].unit_amount
                    price.base_price = basePrices[key];
                    price.guid = item.guid;
                    all[key] = price;
                    return all;
                }, {})
                all[item.name] = tierPrice;
                return all
            }, defaultTiers)
        } else {
            prices = product.stripe_price.filter(p => p.type != 'one_time').reduce((all, item) => {
                all[item.recurring.interval] = {
                    ...item,
                    fakeTier: true,
                    base_price: item
                }
                return all
            }, {
                'year': null,
                'month': null
            });
            // create a fake tier
            prices = {}
        }

        return prices;
    }

    let priceTiers = generatePrices(product);
    let priceSchedule = 'month'

    $:priceSchedule, handleSelectionChange();


    let coupon;
    let couponError;
    let couponLoading = false;
    let couponData, formError;

    function continuePurchase() {
        if (!priceType) {
            formError = 'Please select a plan';
            return;
        }
        $shopData.price = priceType;
        $shopData = $shopData;
        $shopData.payment_interval = priceSchedule;

        if(step && step.validate()){
          stepComplete()
        }
    }

    function handleSelectionChange() {
        if (Object.keys(priceTiers).length === 1) {
            selectPrice(Object.keys(priceTiers)[0], Object.values(priceTiers)[0][priceSchedule]);
        } else {
            priceType = null;
        }
    }

    async function validateCoupon() {
        couponLoading = true;
        couponError = false;
        let [error, couponResponse] = await to(ValidateCoupon.post({
            coupon,
            product_slug: product.slug
        }))

        couponLoading = false;

        if (error) {
            couponError = error;
        } else {
            if(couponResponse.object == 'promotion_code'){
                couponResponse = couponResponse.coupon;
                coupon = couponResponse.id
            }
            if (!couponResponse.valid) {
                couponError = {'error': "Coupon is no longer valid"}
            } else {
                couponData = couponResponse;
                $shopData.coupon = couponResponse;
                //await window.Marketing.tagUser({key: 'coupon', value: couponResponse.id});
            }

        }
    }

    function selectPrice(tier, price) {
        $shopData.tier = tier;
        priceType = price;
        formError = null;
    }

    function onBack() {
        $shopData.productType = null;
        $shopData.tier = null;
        dispatch('back');
    }

    onMount(async () => {
        if(resolvedConfig && resolvedConfig.base_subscription){
            coupon = resolvedConfig.base_subscription;
            await validateCoupon();
        }        
    })

</script>

<style type="text/scss">

  .options {
    display: flex;
    flex-direction: column;
    padding: 10px;    
    justify-content: center;
  }

  .checkbox-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    //width: 300px;
    margin-left: auto;
    margin-right: auto;
    user-select: none;

    & > * {
      margin: .5rem 0.5rem;
    }

  }

  .checkbox-group-legend {
    font-size: 1.5rem;
    font-weight: 700;
    color: #333;
    text-align: center;
    line-height: 1.125;
    margin-bottom: 1.25rem;
  }

  .checkbox-input {
    // Code to hide the input
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;

    &:checked + .checkbox-tile {
      border-color: black;
      box-shadow: 0 5px 10px rgba(#000, 0.1);
      color: black;

      &:before {
        transform: scale(1);
        opacity: 1;
        background-color: black;
        border-color: black;
      }

      .checkbox-icon, .checkbox-label {
        color: black;
      }
    }

    &:focus + .checkbox-tile {
      border-color: black;
      box-shadow: 0 5px 10px rgba(#000, 0.1), 0 0 0 4px #b5c9fc;

      &:before {
        transform: scale(1);
        opacity: 1;
      }
    }
  }

  .checkbox-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 7rem;
    min-height: 7rem;
    border-radius: 0.5rem;
    border: 2px solid #b5bfd9;
    background-color: #fff;
    box-shadow: 0 5px 10px rgba(#000, 0.1);
    transition: 0.15s ease;
    cursor: pointer;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      display: block;
      width: 1.25rem;
      height: 1.25rem;
      border: 2px solid #b5bfd9;
      background-color: #fff;
      border-radius: 50%;
      top: 0.25rem;
      left: 0.25rem;
      opacity: 0;
      transform: scale(0);
      transition: 0.25s ease;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='192' height='192' fill='%23FFFFFF' viewBox='0 0 256 256'%3E%3Crect width='256' height='256' fill='none'%3E%3C/rect%3E%3Cpolyline points='216 72.005 104 184 48 128.005' fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'%3E%3C/polyline%3E%3C/svg%3E");
      background-size: 12px;
      background-repeat: no-repeat;
      background-position: 50% 50%;
    }

    &:hover {
      border-color: black;

      &:before {
        transform: scale(1);
        opacity: 1;
      }
    }
  }

  .checkbox-icon {
    transition: .375s ease;
    color: #494949;

    i {
      font-size: 50px;
    }
  }

  .checkbox-label {
    color: #707070;
    transition: .375s ease;
    text-align: center;
  }

  .customer-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: 1200px) {
      padding-left: 20px;
    }

    @media screen and (max-width: 1200px) {
    }
  }

  .coupon-input {
    display: flex;
    align-items: center;

    input {
      width: 100%
    }

    button {
      font-size: 10px;
      width: 160px;
      margin: 0;
    }

    i {
      color: #0abb0a;
      position: absolute;
      right: 130px;
      top: 32%;
    }

  }

  .price-grid {
    @media screen and (max-width: 1200px) {
      .price {
        .price-title {
          font-size: 10px;
          line-height: 14px;
        }
      }
    }
  }

  .tier-card {
    @apply ring-1 ring-gray-300 w-full max-w-[260px] md:max-w-[300px];
  }

  .tier-card.selected {
    @apply ring-green-900 ring-2;

    .buy-plan {
      background: #046c80;
      border: none;
      box-shadow: none;
      color: white;
    }
  }


</style>


<div class="choose-pricing h-full 2xl:h-auto">
    {#if showBack}
        <div class="mt-4 back cursor-pointer" style="margin-left: 20px;text-align: left;" on:click={onBack}><i
                class="fa-sharp fa-solid fa-arrow-left mr-2"></i> Back
        </div>
    {/if}
    <div class="options">

        <div class="bg-white">
            <div class="mx-auto max-w-7xl px-6 lg:px-8">

                <div class="mx-auto max-w-4xl text-center">
                    <p class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">Pricing plans for
                        all</p>
                </div>

                <div class="mt-6 flex justify-center">
                    <fieldset
                            class="grid grid-cols-2 gap-x-1 rounded-full p-1 text-center text-xs font-semibold leading-5 ring-1 ring-inset ring-gray-200">
                        <legend class="sr-only">Payment frequency</legend>
                        <!-- Checked: "bg-indigo-600 text-white", Not Checked: "text-gray-500" -->
                        <label class="cursor-pointer rounded-full px-2.5 py-1 {priceSchedule === 'month' ? 'bg-black text-white' : ''}">
                            <input bind:group={priceSchedule} type="radio" name="frequency" value="month"
                                   class="sr-only">
                            <span>Monthly</span>
                        </label>
                        <!-- Checked: "bg-indigo-600 text-white", Not Checked: "text-gray-500" -->
                        <label class="cursor-pointer rounded-full px-2.5 py-1 {priceSchedule === 'year' ? 'bg-black text-white' : ''}">
                            <input bind:group={priceSchedule} type="radio" name="frequency" value="year"
                                   class="sr-only">
                            <span>Yearly</span>
                        </label>
                    </fieldset>
                </div>
                {#key $shopData.coupon}
                    <div class="mx-auto mt-5 2xl:mt-10 flex items-center md:items-stretch justify-center gap-3 flex-col md:flex-row">
                        {#each Object.keys(priceTiers) as tier, i}
                            {@const price = calculatePrice(priceTiers[tier][priceSchedule]) }
                            <div class="tier-card rounded-3xl p-4 2xl:p-10"
                                 class:selected={priceType && priceType.id === priceTiers[tier][priceSchedule].id}>
                                <div class="flex items-center justify-between gap-x-4">
                                    <h3 id="tier-freelancer"
                                        class="text-lg font-semibold leading-8 text-gray-900">{tier}</h3>
                                </div>
                                {#if priceTiers[tier][priceSchedule].metadata.description}
                                    <p class="text-sm leading-6 text-gray-600">{priceTiers[tier][priceSchedule].metadata.description}</p>
                                {/if}
                                {#if price.discounted}
                                    <p class="mt-6 flex items-baseline gap-x-1">
                                        <!-- Price, update based on frequency toggle state -->
                                        <span class="text-base font-bold tracking-tight text-gray-700 line-through">${price.original}</span>
                                    </p>
                                {/if}
                                <p class="{!price.discounted ? 'mt-6 ' : ' '} flex items-baseline gap-x-1">
                                    <!-- Price, update based on frequency toggle state -->
                                    <span class="text-4xl font-bold tracking-tight text-shop-default">{#if price.discounted} ${price.value} {:else} ${price.original}  {/if}
                                        <span class="text-xs">USD</span></span>
                                    <!-- Payment frequency, update based on frequency toggle state -->
                                    <span class="text-sm font-semibold leading-6 text-shop-default">/{priceSchedule}</span>
                                </p>
                                <a href="#" on:click|preventDefault={()=>selectPrice(tier,priceTiers[tier][priceSchedule])}
                                   aria-describedby="tier-freelancer"
                                   class="buy-plan mt-6 block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black text-shop-defaul ring-1 ring-inset ring-black hover:ring-black">{priceType && priceType.id == priceTiers[tier][priceSchedule].id ? "Selected" : "Select Plan"}</a>
                                <ul role="list" class="mt-8 space-y-3 text-sm leading-6 text-gray-600 xl:mt-10">
                                    {@html priceTiers[tier][priceSchedule].description}
                                </ul>
                            </div>
                        {/each}
                    </div>
                {/key}
            </div>
        </div>

        {#if product.allow_belt_purchase}
            <div class="relative my-5">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-300"></div>
                </div>
                <div class="relative flex justify-center">
        <span class="bg-white px-2 text-gray-500">
          <svg class="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"/>
          </svg>
        </span>
                </div>
            </div>
            <h3 id="tier-personal" class="text-base font-semibold leading-1 text-shop-default text-center">One Time
                Hardware Cost</h3>
            <p class="mt-2 mb-5 flex-wrap text-center flex flex-col items-center">
                <span class="text-3xl font-bold tracking-tight text-gray-900 text-center">$129 for sensor and belt</span>
                {#if $shopData.coupon}
                <span style=" color: #eea2a2; font-weight: normal;" class="text-xs tracking-tight text-gray-900 text-center">* Price may change during the order finalization based on the coupon used</span>
                {/if}
            </p>
            <div class="flex justfiy-center self-center">
                <label for="wants_belt" class="block flex items-center ">
                    <input type="checkbox" id="wants_belt" bind:checked={$shopData.remove_belt}
                           class="mr-2 block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                    I already have a belt, remove from purchase.
                </label>
            </div>

        {:else}
            <div class="rounded-md bg-blue-50 p-4 mt-6">
                <div class="flex justify-center items-center">
                    <div class="flex-shrink-0 ml-auto">
                        <svg class="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </div>
                    <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-xl text-blue-700  font-semibold">2 free months are included in the annual pricing</p>
                    </div>
                </div>
            </div>
        {/if}

        <div class="coupon-input min-w-[330px] w-1/2 mt-6 mx-auto mb-4 ">
            <div>
                <label for="discount-code-mobile" class="block text-left text-sm font-medium text-gray-700">Discount code</label>
                <div class="mt-1 flex space-x-4 relative">
                    <input type="text"
                           bind:value={coupon}
                           class="{couponError ? 'border-red-400' : 'border-gray-300' } mr-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:opacity-50"
                           disabled={!!resolvedConfig?.base_subscription}
                    >
                    <button
                            on:click={validateCoupon}
                            disabled={!!resolvedConfig?.base_subscription}
                            class="rounded-md bg-gray-200 px-4 text-sm font-medium text-gray-600 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-50 disabled:opacity-50">{couponLoading ? '...' : 'Apply'}
                    </button>
                    {#if couponData}
                        <i class="fa-solid fa-badge-check"></i>
                    {/if}
                </div>
                {#if resolvedConfig?.base_subscription}
                    <p class="p-2 bg-blue-50 text-blue-600 text-sm px-2 py-1 mt-2 rounded-md">{org.nme} has auto applied a coupon</p>
                {/if}
            </div>
        </div>
        {#if couponError}
            <div class="rounded-md text-sm text-red-500 bg-red-50 px-3 py-2 mb-3 mt-2 w-1/2 mx-auto">Coupon not valid.
            </div>
        {/if}
        <div class="pb-2 relative text-center">
            <button type="button" on:click={continuePurchase}
                    disabled={couponLoading}
                    class="mb-4 min-w-[330px] w-1/2 mx-auto mt-5 items-center rounded-md border border-transparent bg-black px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                Continue
            </button>
            {#if formError}
                <p class="absolute bottom-0 left-0 text-xs text-red-600 w-full text-center">{formError}</p>
            {/if}
        </div>

    </div>
</div>
